import HttpQuery from "@mnjsplatform/data/lib/api/HttpQuery";

class WorkListApi {
    static getWorkListPagesLinks(tabNum) {
        let hq = new HttpQuery();
        return hq.makeApiCallPost("WorkDocuments/GetWorkListPagesLinks", {tabNum:tabNum});
    }
}

export default WorkListApi
